import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import MainContainer from "../../container/MainContainer";
import { Link, useHistory, useParams } from "react-router-dom";
import Arrow from "../../images/Arrow-Right.svg";
import Details from "./Details";
import EventInformation from "./EventInformation";
import EventTickets from "./EventTickets";
import { EDIT_EVENT } from "../../mutation/EditEvent";
import { EDIT_NEW_TICKETS } from "../../mutation/InsertNewTickets";
import { EDIT_TICKET } from "../../mutation/UpdateEventTicket";
import { useMutation } from "@apollo/client";
import { hasuraClient } from "../../apolloClient";

const steps = ["General info", "Ticket details", "Review & Publish"];

const CreateEvent = (props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [step1Value, setStep1Value] = useState();
  const [step2Value, setStep2Value] = useState();
  const [modalShowD, setModalShowD] = React.useState(false);

  const [location_text, setLocation_text] = useState(null);
  const [cordinate, setCordinate] = useState(null);
  const [ticketUrl, setTicketUrl] = useState("");

  const history = useHistory();
  const params = useParams();

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = (value, step) => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [EditEvent] = useMutation(EDIT_EVENT, {
    client: hasuraClient,
  });

  const [InsertNewTicket] = useMutation(EDIT_NEW_TICKETS, {
    client: hasuraClient,
  });

  const [EditTicket] = useMutation(EDIT_TICKET, {
    client: hasuraClient,
  });

  const yesHandler = (firstValue, secondValue) => {
    let newTickets = [];

    var value = secondValue ? secondValue : step2Value;
    for (let i = 0; i < value.event_paid_ticket_details.length; i++) {
      if (!value.event_paid_ticket_details[i].id) {
        newTickets.push({
          ...value.event_paid_ticket_details[i],
          event_id: params.id,
        });
      }
    }
    value.event_paid_ticket_details.map((ticket, index) => {
      const id = ticket.id;
      let sampleTicket = {
        option_name: ticket.option_name,
        description: " ",
        price: ticket.price,
        quantity_available: ticket.quantity_available,
      };
      EditTicket({
        variables: {
          id: id,
          data: sampleTicket,
        },
      })
        .then(() => {})
        .catch(() => {});
    });
    let values = {
      id: props?.data?.events_by_pk?.id,
      cover_photo: firstValue ? firstValue.image_url : step1Value.image_url,
      cover_photo_path: firstValue
        ? firstValue?.image_path
        : step1Value.image_path,
      is_all_day: false,
      ...step1Value,
      ...firstValue,
      location_text: location_text,
      location: {
        type: "Point",
        coordinates: cordinate,
      },
      event_payment_type: value.event_payment_type,
      total_attendees: value.total_attendees,
      external_ticket_url: ticketUrl ? ticketUrl : null,
      is_ticket_required:value.is_ticket_required,
    };
    delete values.image_path;
    delete values.image_url;

    EditEvent({
      variables: values,
    })
      .then(() => {
        history.push("/event");
        setModalShowD(false);
      })

      .catch(() => {});

    if (newTickets.length > 0) {
      InsertNewTicket({
        variables: {
          data: newTickets,
        },
      }).catch(() => {});
    }
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <EventInformation
            modalShowD={modalShowD}
            onPressNo={() => {
              setModalShowD(false);
            }}
            onPressYes={yesHandler}
            editMode={props.editMode}
            handleNext={handleNext}
            setStep1Value={setStep1Value}
            step1Data={step1Value}
            data={props?.data}
            setLocation_text={setLocation_text}
            setCordinate={setCordinate}
            location_text={location_text}
            cordinate={cordinate}
          />
        );
      case 1:
        return (
          <EventTickets
            modalShowD={modalShowD}
            onPressNo={() => {
              setModalShowD(false);
            }}
            onPressYes={yesHandler}
            handleBack={handleBack}
            handleNext={handleNext}
            setStep2Value={setStep2Value}
            step2Data={step2Value}
            setTicketUrl={setTicketUrl}
            ticketUrl={ticketUrl}
            data={props?.data}
          />
        );
      case 2:
        return (
          <Details
            modalShowD={modalShowD}
            onPressNo={() => {
              setModalShowD(false);
            }}
            onPressYes={() => {
              history.push("/event");
              setModalShowD(false);
            }}
            editMode={props.editMode}
            data={props?.data?.events_by_pk}
            handleBack={handleBack}
            step1Value={step1Value}
            step2Value={step2Value}
            location_text={location_text}
            ticketUrl={ticketUrl}
            cordinate={cordinate}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const data = props?.data?.events_by_pk;
    if (data) {
      const value = {
        id: data?.id,
        name: data.name.trimStart().trimEnd(),
        location_text: data.location?.location_text,
        categories: data.categories,
        description: data.description,
        date_time: new Date(data.date_time),
        end_date: new Date(data.end_date),
        start_date_time: new Date(data.start_date_time),
        end_date_time: new Date(data.end_date_time),
        image_path: data?.cover_photo_path,
        image_url: data?.cover_photo,
      };

      setCordinate([
        data?.location?.latitude_double,
        data?.location?.longitude_double,
      ]);
      setStep1Value(value);
      setStep2Value(data);
      setLocation_text(data.location?.location_text);
      setTicketUrl(data.external_ticket_url);
    }
  }, [props.editMode, props.data]);

  return (
    <MainContainer active="events">
      <section className="post-block">
        <div className="main-title">
          <div className="back-button">
            <Link to="/event">
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h1>{props.editMode ? "Edit Event" : "Create Event"}</h1>
          </div>
          {props.editMode && (
            <div className="edit-btn">
              <button
                onClick={() => {
                  setModalShowD(true);
                }}
              >
                Save and exit
              </button>
            </div>
          )}
        </div>
        <div className="event-step-cover">
          <ul className="eventstep-menu">
            <li className={activeStep === 0 ? "active" : ""}>
              <p>1. General info</p>
            </li>
            <li className={activeStep === 1 ? "active" : ""}>
              <p>2. Ticket details</p>
            </li>
            <li className={activeStep === 2 ? "active" : ""}>
              <p>3. Review & Publish</p>
            </li>
          </ul>

          <div className="event-main">
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>{getStepContent(activeStep)}</React.Fragment>
            )}
          </div>

          {/* <NameYourEvent /> */}
          {/* <DateTime /> */}
          {/* <Details /> */}

          {/* <ReviewPublish />  */}
        </div>
      </section>
    </MainContainer>
  );
};

export default CreateEvent;
